var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5837 11.4583C16.8848 11.4583 18.7503 9.59285 18.7503 7.29167C18.7503 4.99048 16.8848 3.125 14.5837 3.125C12.2825 3.125 10.417 4.99048 10.417 7.29167C10.417 9.59285 12.2825 11.4583 14.5837 11.4583Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.5003 12.2396C15.2285 12.2396 17.4482 10.0198 17.4482 7.29167C17.4482 4.56354 15.2285 2.34375 12.5003 2.34375C9.7722 2.34375 7.55241 4.56354 7.55241 7.29167C7.55241 10.0198 9.7722 12.2396 12.5003 12.2396ZM12.5003 3.90625C14.367 3.90625 15.8857 5.425 15.8857 7.29167C15.8857 9.15833 14.367 10.6771 12.5003 10.6771C10.6337 10.6771 9.11491 9.15833 9.11491 7.29167C9.11491 5.425 10.6337 3.90625 12.5003 3.90625ZM15.6253 13.8021H9.37533C6.07324 13.8021 3.38574 16.4896 3.38574 19.7917C3.38629 20.5512 3.68827 21.2795 4.22537 21.8166C4.76246 22.3537 5.49076 22.6557 6.25033 22.6562H18.7503C19.5099 22.6557 20.2382 22.3537 20.7753 21.8166C21.3124 21.2795 21.6144 20.5512 21.6149 19.7917C21.6149 16.4896 18.9274 13.8021 15.6253 13.8021ZM18.7503 21.0938H6.25033C5.53262 21.0938 4.94824 20.5094 4.94824 19.7917C4.94962 18.618 5.41649 17.4927 6.24643 16.6628C7.07637 15.8328 8.20161 15.366 9.37533 15.3646H15.6253C16.799 15.366 17.9243 15.8328 18.7542 16.6628C19.5842 17.4927 20.051 18.618 20.0524 19.7917C20.0524 20.5094 19.468 21.0938 18.7503 21.0938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName1);
export default __webpack_public_path__ + "static/media/name1.2497c80001fcbd57ef003f12b09dcf90.svg";
export { ForwardRef as ReactComponent };